// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const DocumentMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2806 2.30154H6.73725C5.00391 2.29487 3.58391 3.6757 3.54225 5.40904V14.3565C3.50475 16.1082 4.89475 17.5582 6.64558 17.5957C6.67641 17.5957 6.70725 17.5965 6.73725 17.5957H13.3939C15.1356 17.534 16.5122 16.099 16.5022 14.3565V6.6982L12.2806 2.30154Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.0625 2.29175V4.71591C12.0625 5.89925 13.02 6.85841 14.2033 6.86175H16.4983" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
